import React, { Component, Fragment, useState } from "react";

import { Link } from "react-router-dom";

import Header from "../../components/Header";
import Footer from "../../components/Footer";
import Sidebar from "../../components/Sidebar";
import edit from '../../assets/images/edit.png'
import myp1 from '../../assets/images/myp_1.svg'
import myp2 from '../../assets/images/myp_1.svg'
import { useNavigate } from "react-router";
import { useTranslation, I18nextProvider } from "react-i18next";

import { getUserDetails } from "../../Features/SiteSettings/siteSettingSlice";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { getUserStatistics, getOverAllStatisstics } from "../../Features/Statistics/statisticsSlice";

import { useCustomizeContext } from "../../context";
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import { SkeletonTheme } from 'react-loading-skeleton';

import { PatternFormat } from "react-number-format";

import { addCpfUserProfile } from "../../Features/Profile/profileSlice.js";

import { Notify } from "notiflix/build/notiflix-notify-aio";


const Myprofile = (props) => {
   const { t, i18n } = useTranslation();

   const [cpfNumber, setCpfNumber] = useState("");

   const [update, setUpdate] = useState("");


   let navigate = useNavigate();
   let dispatch = useDispatch();

   const {
      loader: {
         loading, setLoading,
      },
      languageContext: {
         language, setLanguage,
         changeLanguageRes, setChangeLanguageRes,
      },
      sideMenu: {
         classIsActive, setClassIsActive
      },
   } = useCustomizeContext();

   const [userDetails, setUserDetails] = useState("");
   const [statissticsRes, setStatisticsRes] = useState("");

   const [isCpf, setIsCpf] = useState(false);


   useEffect(() => {
      document.body.classList.remove("SideMenuOpen");
      setClassIsActive(false);
   }, []);

   useEffect(() => {
      getUserInfo();
      getStatissticsGame();
   }, [changeLanguageRes, update]);

   const getUserInfo = async () => {
      setLoading(true);
      let res = await dispatch(getUserDetails());
      if (res?.status === true && res?.data?.details?.type?.toLowerCase() === "google" && res?.data?.details?.CPF === "") {
         setIsCpf(true);
      }
      else {
         setIsCpf(false);
      }
      setTimeout(() => {
         if (res?.status === true) {
            setUserDetails(res?.data);
            setLoading(false);
         }
         else {
            setLoading(false);
         }
      }, 1000);
   }

   const getStatissticsGame = async () => {
      setLoading(true);
      let res = await dispatch(getOverAllStatisstics());
      setTimeout(() => {
         if (res?.status === true) {
            setStatisticsRes(res?.data);
            setLoading(false);
         }
         else {
            setLoading(false);
         }
      }, 1000);
   }


   const addCpf = async () => {
      if (cpfNumber) {
         let changeCPF = cpfNumber?.replaceAll('.', '').replaceAll('-', '');
         let data = {
            "CPF": changeCPF
         }
         setLoading(true);
         let addCpfRes = await dispatch(addCpfUserProfile(data));
         if (addCpfRes?.status) {
            setLoading(false);
            setIsCpf(false);
            setUpdate(addCpfRes);
         }
         else {
            setLoading(false);
         }
      }
      else {
         Notify.failure(`${t('CPF is Required')} !`, {
            theme: "colored",
            showOnlyTheLastOne: true,
            clickToClose: true,
            timeout: 1500,
            position: "center-top"
         });
      }

   }

   return (
      <Fragment>
         <Header />
         <div class="mainbody-content">
            <Sidebar />
            <div class="center-maincnt">
               <div class="inr-container">
                  <div class="center-inrcnt">
                     <div className="myprofilepage-maincnt">
                        <section class="my_profile-sec">
                           <h2>{t("My Profile")}</h2>
                           <div class="my_pro_cdtl">
                              <div class="row justify-content-center align-items-center">
                                 <div class="col-lg-7 bor_rig my-3">
                                    <SkeletonTheme baseColor="#444" height="110px" width="110px" highlightColor="#fff" borderRadius="80px">
                                       <div class="mar_cd ">
                                          {
                                             isCpf ?
                                                <div class="row align-items-center">
                                                   <div class="col-xl-auto">

                                                   </div>
                                                   <div class="col">
                                                      <div>
                                                         <h2>{t('AddCpf')}</h2>
                                                         <div class="input-group ">


                                                            <PatternFormat
                                                               className="form-control"
                                                               allowLeadingZeros
                                                               placeholder={t("CPF Number")}
                                                               format="###.###.###-##"
                                                               onChange={(event) => setCpfNumber(event.target.value)}
                                                               name="cpf_No"
                                                               value={cpfNumber}
                                                            />

                                                            <div class="input-group-append">
                                                               <span class="input-group-text"
                                                                  id="basic-addon2"><Link style={{ cursor: 'pointer' }} to="" onClick={addCpf}>submit</Link></span>
                                                            </div>
                                                         </div>
                                                      </div>
                                                   </div>
                                                </div>
                                                :
                                                <div class="row align-items-center">
                                                   <div class="col-xl-auto">
                                                      <div class="img_edit">
                                                         {userDetails?.details?.profile_picture ? (
                                                            <img src={userDetails?.details?.profile_picture} style={{ height: "100px", width: "100px", borderRadius: "inherit" }} alt="" />
                                                         ) : (<Skeleton />)}
                                                         <div class="setting-pro-2">
                                                            <div class="variants">
                                                               <div class='file'>
                                                                  <label for='input-file'>
                                                                     <img src={edit} alt="" />
                                                                  </label>
                                                                  <button style={{ cursor: "pointer" }} id='input-file' onClick={() => navigate("/editprofile")} />
                                                               </div>
                                                            </div>
                                                         </div>
                                                      </div>
                                                   </div>
                                                   <div class="col">
                                                      <div>
                                                         <h2>{userDetails?.details?.username ? userDetails?.details?.username : "Loading ..." || <Skeleton />}</h2>
                                                         <h3 class="mb-3">{t("User ID")} : {userDetails?.details?.uid ? userDetails?.details?.uid : "Loading ..."}</h3>
                                                         <div class="input-group ">
                                                            <input type="text" class="form-control" disabled="true" value={userDetails?.email ? userDetails?.email : "Loading ..."} />
                                                            <div class="input-group-append">
                                                               <span class="input-group-text"
                                                                  id="basic-addon2"><Link style={{ cursor: 'unset' }} to="">{userDetails?.details?.verified === true ? "Verified" : "Non-Verified"}</Link></span>
                                                            </div>
                                                         </div>
                                                      </div>
                                                   </div>
                                                </div>
                                          }
                                       </div>
                                    </SkeletonTheme>
                                 </div>
                                 <div class="col-lg-5 my-3">
                                    <div class="sta_sti">
                                       <h2 class="mb-3">{t("Statistics")}</h2>
                                       <div class="d-flex align-items-center justify-content-between">
                                          <div class="d-flex align-items-center">
                                             <div class="img_myp mr-1">
                                                <img src={myp1} alt="" />
                                             </div>
                                             <h3>{t("Number of wins")}</h3>
                                          </div>
                                          <h4>{statissticsRes?.totalWins}</h4>
                                       </div>
                                       <div class="d-flex align-items-center justify-content-between mb-3">
                                          <div class="d-flex align-items-center" >
                                             <div class="img_myp mr-1">
                                                <img src={myp2} alt="" />
                                             </div>
                                             <h3>{t("Number of loss")}</h3>
                                          </div>
                                          <h4>{statissticsRes?.totalLoss}</h4>
                                       </div>
                                       <button class="btn" onClick={() => navigate("/statistics")}>{t("See all")}</button>
                                    </div>

                                 </div>
                              </div>

                           </div>
                        </section>
                     </div>

                  </div>
                  <Footer />
               </div>
            </div>
         </div>
      </Fragment>
   );

}

export default Myprofile;